module.exports = __webpack_public_path__ + "static/aboutus-2-min-e910f822fd23d2dfe9f3a212a4fc19d1.webp";